import { reactive } from 'vue'
import Api from '../api/Survey'

const state = reactive({
    id: null,
    questions: [],
    answers: [],
    show: false,
    submitting: false,
    success: '',
})

export default {
    state,
    initState () {
        state.id = null
        state.questions = []
        state.answers = []
        state.show = false
        state.submitting = false
        state.success = ''
    },

    bootTheoryPassedSurvey() {
        this.initState();
        Api.GetTheoryPassedSurvey().then(res => {
            if (!res.success) {
                return;
            }

            state.id = res.survey.id
            res.survey.questions.map(question => {
                question.missing_input = false
                state.questions.push(question)
            })

            state.show = true
        })
    },

    submit() {
        if (!this.canSubmit(true) || state.submitting) {
            return
        }
        state.submitting = true
        Api.Submit({ id: state.id, answers: state.answers }).then(res => {
            state.submitting = false
            console.log(res.message)
            if (res.success) {
                state.success = res.message
            } else {
                state.error = $t('Oops, det skjedde noe galt. Prøv igjen senere.')
            }
        }).catch(() => {
            state.error = $t('Oops, det skjedde noe galt. Prøv igjen senere.')
            state.submitting = false
        })
    },

    canSubmit(showError) {
        const _this = this

        // Check if all visible questions have been answered
        return state.questions.filter(question => {
            if (_this.shouldDisplayQuestion(question.id) && !_this.questionHasAnswer(question.id)) {
                question.missing_input = showError
                return true
            }
            question.missing_input = false
            return false
        }).length === 0;
    },

    getQuestions() {
        return state.questions
    },

    findQuestion(id) {
        return state.questions.find(question => {
            return question.id === id;
        })
    },

    shouldDisplayQuestion(id) {
        const isFollowUp = state.questions.reduce((carry, question) => {
            question.alternatives.filter(alt => {
                return alt.followup_question_id === id
            }).map(alt => {
                carry.push(alt.id)
            })
            return carry
        }, [])

        if (!isFollowUp.length) {
            return true;
        }

        const hasAnswer = state.answers.find(answer => {
            return isFollowUp.indexOf(answer.alternative_id) > -1
        })

        return hasAnswer ? true : false
    },

    questionHasAnswer(questionId) {
        return state.answers.find(answer => {
            return answer.question_id === questionId
        })
    },

    setQuestionAnswer(questionId, value, alternativeId) {
        const answer = this.questionHasAnswer(questionId)
        if (!value && !alternativeId) {
            // Answer removed
            state.answers = state.answers.filter(answer => {
                return (answer.question_id !== questionId)
            })
        }

        if (answer) {
            state.answers = state.answers.map(answer => {
                if (answer.question_id === questionId) {
                    answer.value = value
                    answer.alternative_id = alternativeId
                }
                return answer
            })
            return
        }

        state.answers.push({
            question_id: questionId,
            value: value,
            alternative_id: alternativeId,
        })

        this.canSubmit()
    },

    setQuestionMultiAnswer(_questionId, _value, _add) {

    },

    description() {
        switch (state.id) {
            case 1:
            default:
                return $t("Takk, informasjonen din har blitt lagret.") + " <br>" + $t("Vi setter pris på om du kan svare på et kort spørsmål:")
        }
    },
    show () {
        return state.show;
    },
    close () {
        state.show = false;
    },
}